module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "dialogWrapper"
  }, [_c('div', {
    staticClass: "dialog"
  }, [_c('header', [_vm._v("\n          " + _vm._s(_vm.title) + "\n          "), _c('span', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('main', [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3977065a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyDialog.vue
// module id = 191
// module chunks = 1